/**
* Content Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-slider__slider' ).slick( {
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        asNavFor: '.content-slider__slider-text, .content-slider__slider-tagline',
        prevArrow: $( '.content-slider__slider-prev' ),
        nextArrow: $( '.content-slider__slider-next' ),
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
      } );

      $( '.content-slider__slider-text' ).slick( {
        dots: false,
        infinite: true,
        arrows: false,
        speed: 500,
        fade: true,
        asNavFor: '.content-slider__slider, .content-slider__slider-tagline',
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
      } );

      $( '.content-slider__slider-tagline' ).slick( {
        dots: false,
        infinite: true,
        arrows: false,
        speed: 500,
        fade: true,
        asNavFor: '.content-slider__slider, .content-slider__slider-text',
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-slider', COMPONENT );
} )( app );
